import Grid from "@material-ui/core/Grid";
import { instance } from "Actions/AxiosInstance";
import { setSaveProgress, removeSaveProgress } from "Actions/SaveProgressAction";
import SectionHeaderExtraSmall from "Component/Headers/sectionHeaderExtraSmall";
import { ErrorMessages } from "Constants";
import $ from "jquery";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import Popover from "@material-ui/core/Popover";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CallOutNew from "Component/Headers/callOutNew";
import Tooltip from "@material-ui/core/Tooltip";

import ListItemText from "@material-ui/core/ListItemText";
import DynamicForm from "Component/DynamicForm";
import "react-quill/dist/quill.core.css";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import ReactQuill from "react-quill";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { convertTOBase64 } from "Utils";
import VARIBALES from "./variables";
import "./index.scss";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

class email extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: props.postData,
      modules: props.modules2,
      formats,
      sortmenu: false,
      sort_anchorEl: null,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.openPoper = this.openPoper.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updatePostdata = this.updatePostdata.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
      // onSaveDraft: this.onSaveDraft,
      onSaveDraft: this.state.postData.mailtemplateid ? "" : this.onSaveDraft,
    });
    const x = () => {
      $("span").removeClass("ql-selected");
    };
    x();
    const placeholderPickerItems = Array.prototype.slice.call(
      document.querySelectorAll(".ql-placeholder .ql-picker-item"),
    );

    placeholderPickerItems.forEach(
      (item) => (item.textContent = item.dataset.value),
    );
    document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
      "{ }";
    // document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
    //   "{ }";
  }

  handleChange(key, value) {
    const { postData } = this.state;
    if (key == "emailbodypath") {
      postData[key] = value;
      postData.emailvariableids = 1;
    }
    postData[key] = value;
    this.setState({
      postData,
    });
  }

  openPoper(e) {
    this.setState({
      open: !this.state.open,
      create_anchorEl: e.currentTaget,
    });
  }

  updatePostdata(key, value) {
    const { postData } = this.state;
    postData[key] = `${postData.subject ? postData.subject : ""}{${
      value.variablevalue
    }}`;
    // postData.subjectvariableids = value.displayvalue;
    this.setState({
      postData,
      open: false,
      sortmenu: false,
      sort_anchorEl: null,
    });
  }

  async onSubmit() {
    const { subject, emailbodypath } = this.state.postData;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const { postData } = this.state;
    const { letterVariables } = this.props;
    const subjectvariableids = [];
    const emailvariableids = [];
    letterVariables.forEach((x) => {
      if (subject && subject.includes(`{${x.variablevalue}}`)) {
        subjectvariableids.push(x.displayvalue);
      }
      if (
        emailbodypath &&
        emailbodypath.includes(`{${x.variablevalue}}`) &&
        x.displayvalue != VARIBALES.letterlink
      ) {
        emailvariableids.push(x.displayvalue);
      }
    });
    postData.subjectvariableids = subjectvariableids.join(",") || null;
    postData.emailvariableids = emailvariableids.join(",") || null;
    postData.isdraft = false;
    if (!postData.subject) {
      this.props.enqueueSnackbar(" Please enter subject of template", {
        variant: "error",
      });
      return;
    } else if (!postData.emailbodypath || postData.emailbodypath == "") {
      this.props.enqueueSnackbar(" Please enter body of mail template", {
        variant: "error",
      });
      return;
    } else if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      if (postData.mailtemplateid && postData.emailbody != emailbodypath) {
        postData.emailbody = postData.emailbody
          .toString();
        const data = {
          filename: "Email_template.html",
          appproductid: null,
          contenttype: "application/html",
          bufferdata: convertTOBase64(postData.emailbody),
          employeeid: null,
        };
        const result = await instance.post("employee/uploadbufferfile", data);
        postData.emailbodypath = result.data.result[0].imagepath;
        delete postData.isactive;
        delete postData.templatecode;
        delete postData.mastermailtemplateid;
        // postData.deletefile.push(postData.bemailbodypath);
      } else {
        postData.emailbodypath =
          postData.emailbodypath &&
          postData.emailbodypath.toString();
        const data = {
          filename: "mailtemplate.html",
          appproductid: null,
          contenttype: "application/html",
          bufferdata: convertTOBase64(postData.emailbodypath),
          employeeid: null,
        };
        await instance
          .post("employee/uploadbufferfile", data)
          .then((result) => {
            postData.emailbodypath = result.data.result[0].imagepath;
          });
      }

      delete postData.emailbody;

      instance
      .post("subscription/configmailtemplate", [postData])
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
        this.props.history.push(`${this.props.match.path}/list`);
        this.props.getMailTemplate();
        this.props.removeSaveProgress();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.props.removeSaveProgress();
      });
    }
  }

  async onSaveDraft() {
    const { subject, emailbodypath } = this.state.postData;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const { postData } = this.state;
    const { letterVariables } = this.props;
    const subjectvariableids = [];
    const emailvariableids = [];
    letterVariables.forEach((x) => {
      if (subject && subject.includes(`{${x.variablevalue}}`)) {
        subjectvariableids.push(x.displayvalue);
      }
      if (
        emailbodypath &&
        emailbodypath.includes(`{${x.variablevalue}}`) &&
        x.displayvalue != VARIBALES.letterlink
      ) {
        emailvariableids.push(x.displayvalue);
      }
    });
    postData.subjectvariableids = subjectvariableids.join(",") || null;
    postData.emailvariableids = emailvariableids.join(",") || null;
    postData.isdraft = true;
    if (postData.mailtemplateid) {
      if (postData.emailbody != emailbodypath) {
        postData.emailbody = postData.emailbody
          .toString();
        const data = {
          filename: "Email_template.html",
          appproductid: null,
          contenttype: "application/html",
          bufferdata: convertTOBase64(postData.emailbody),
          employeeid: null,
        };
        const result = await instance.post("employee/uploadbufferfile", data);
        postData.emailbodypath = result.data.result[0].imagepath;
        delete postData.isactive;
        delete postData.templatecode;
        delete postData.mastermailtemplateid;
        // postData.deletefile.push(postData.bemailbodypath);
      }
    } else if (postData.emailbodypath) {
      postData.emailbodypath = postData.emailbodypath
        .toString();
      const data = {
        filename: "mailtemplate.html",
        appproductid: null,
        contenttype: "application/html",
        bufferdata: convertTOBase64(postData.emailbodypath),
        employeeid: null,
      };
      await instance.post("employee/uploadbufferfile", data).then((result) => {
        postData.emailbodypath = result.data.result[0].imagepath;
      });
    }
    if (!postData.subject) {
      this.props.enqueueSnackbar(" Please enter subject", {
        variant: "error",
      });
    } else {
      delete postData.emailbody;
      delete postData.templatecode;
      postData.emailbodypath = postData.emailbodypath
        ? postData.emailbodypath
        : null;


      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        instance
        .post("subscription/configmailtemplate", [postData])
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}/list`);
          this.props.getMailTemplate();
          this.props.removeSaveProgress();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
          this.props.removeSaveProgress();
        });
      }
    }
  }

  // async onSaveDraft() {
  //   const { subject, emailbodypath } = this.state.postData;
  //   const { postData } = this.state;
  //   const { letterVariables } = this.props;
  //   const subjectvariableids = [];
  //   const emailvariableids = [];
  //   letterVariables.forEach((x) => {
  //     if (subject && subject.includes(`{${x.variablevalue}}`)) {
  //       subjectvariableids.push(x.displayvalue);
  //     }
  //     if (
  //       emailbodypath &&
  //       emailbodypath.includes(`{${x.variablevalue}}`) &&
  //       x.displayvalue != VARIBALES.letterlink
  //     ) {
  //       emailvariableids.push(x.displayvalue);
  //     }
  //   });
  //   postData.subjectvariableids = subjectvariableids.join(",") || null;
  //   postData.emailvariableids = emailvariableids.join(",") || null;
  //   postData.isdraft = true;
  //   if (postData.mailtemplateid) {
  //     if (postData.emailbody != emailbodypath) {
  //       postData.emailbody = postData.emailbody
  //         .toString()
  //         .replace(/(<([^>]+)>)/gi, "");
  //       const data = {
  //         filename: "Email_template.html",
  //         appproductid: null,
  //         contenttype: "application/html",
  //         bufferdata: convertTOBase64(postData.emailbody),
  //         employeeid: null,
  //       };
  //       const result = await instance.post("employee/uploadbufferfile", data);
  //       postData.emailbodypath = result.data.result[0].imagepath;
  //       delete postData.isactive;
  //       delete postData.templatecode;
  //       delete postData.mastermailtemplateid;
  //       // postData.deletefile.push(postData.bemailbodypath);
  //     }
  //   } else {
  //     postData.emailbodypath =  postData.emailbodypath && postData.emailbodypath
  //       .toString()
  //       .replace(/(<([^>]+)>)/gi, "");
  //     const data = {
  //       filename: "mailtemplate.html",
  //       appproductid: null,
  //       contenttype: "application/html",
  //       bufferdata: convertTOBase64( postData && postData.emailbodypath),
  //       employeeid: null,
  //     };
  //     await instance.post("employee/uploadbufferfile", data).then((result) => {
  //       console.log("result: ", result.data.result[0].imagepath);
  //       postData.emailbodypath = result.data.result[0].imagepath;
  //       console.log("postData.sectionbodypath: ", postData.emailbodypath);
  //       // this.setState({ postData });
  //       console.log("postData: ", postData);
  //     });
  //   }
  //   if (!postData.subject) {
  //     this.props.enqueueSnackbar(" Please enter subject of template", {
  //       variant: "error",
  //     });
  //   } else if (!postData.emailbodypath) {
  //     this.props.enqueueSnackbar(" Please enter body of mail template", {
  //       variant: "error",
  //     });
  //   } else {
  //     delete postData.emailbody;

  //     instance
  //       .post("subscription/configmailtemplate", [postData])
  //       .then(() => {
  //         this.props.enqueueSnackbar(ErrorMessages.E0000, {
  //           variant: "success",
  //         });
  //         this.props.history.push(`${this.props.match.path}/list`);
  //         this.props.getMailTemplate();
  //       })
  //       .catch((error) => {
  //         const CommonError = error.response
  //           ? error.response.data.error.message
  //           : error.message;
  //         this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //       });
  //   }
  // }

  render() {
    const { subject, emailbodypath, mailtemplateid, emailbody } =
      this.state.postData;
    const { letterVariables } = this.props;

    return (
      <div>
        <Grid container style={{ alignItems: "center" }}>
          <Grid item xs={12} md={8} sm={12}>
            <DynamicForm
              fields={textinputconverter({
                value: subject,
                label: "Subject",
                placeholder: "Enter subject",
              })}
              onChange={(e) => this.handleChange("subject", e)}
            />
          </Grid>
          <Grid item md={2} sm={12}>
            <Tooltip title="Select variables">
              <div
                onClick={(e) =>
                  this.setState({
                    sortmenu: true,
                    sort_anchorEl: e.currentTarget,
                  })
                }
                className="cursor-pointer margin-left-16"
                style={{ color: "#057cff" }}
              >
                {" { } "}
              </div>
            </Tooltip>
          </Grid>
        </Grid>
        <CallOutNew
          classnames="bg-light-blue"
          header="This subject will be visible to the employee when the letter is sent."
          emoji="📌"
          textcolor="#1e8ced"
        />
        <Grid container>
          <Grid item xs={12} md={8} sm={12}>
            <p className="smalll-dark-secondary margin-bottom-8">
              Draft your mail below that will be saved as a template. 📝
            </p>
            <div className="margin-top-8 margin-bottom-8 pipeline-mail-template">
              <ReactQuill
                theme="snow"
                value={
                  (mailtemplateid != null ? emailbody : emailbodypath) || ""
                }
                modules={this.state.modules}
                formats={this.state.formats}
                onChange={(value) => {
                  this.handleChange(
                    mailtemplateid != null ? "emailbody" : "emailbodypath",
                    value,
                  );
                }}
              />
            </div>
            <div className="display-table">
              <SectionHeaderExtraSmall header="📌 Press ‘ { } ‘ to see a selectable list of all possible placeholder variables." />
            </div>
          </Grid>
        </Grid>
        <Popover
          open={this.state.sortmenu}
          anchorEl={this.state.sort_anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() =>
            this.setState({
              sortmenu: false,
              sort_anchorEl: null,
            })
          }
          className="margin-top-8"
        >
          <Paper style={{ width: 250 }}>
            <List className="cursor-pointer thin-scroll">
              {letterVariables &&
                letterVariables
                  .filter(
                    (option) =>
                      option.displayvalue != VARIBALES.signatory &&
                      option.displayvalue != VARIBALES.letterlink,
                  )
                  .map((option) => (
                    <ListItem
                      className="padding-right-0 padding-top-2 padding-bottom-2"
                      onClick={() => this.updatePostdata("subject", option)}
                      style={{ height: 30 }}
                    >
                      <ListItemText style={{ paddingTop: 11 }}>
                        <p className="small-dark-secondary">
                          {option.displayname}
                        </p>
                      </ListItemText>
                    </ListItem>
                  ))}
            </List>
          </Paper>
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(email));
